import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Table,
  message,
  Form,
  Modal,
  Select,
  Spin,
  Space,
  Row,
  Col,
  Tooltip,
  Card,
  Typography,
  Input,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { MdAddHome } from "react-icons/md";
import { EyeOutlined, CloseCircleOutlined, DeploymentUnitOutlined, CarOutlined } from "@ant-design/icons";
import { AiFillAlert, AiFillDelete, AiFillEdit } from "react-icons/ai";
import { IoReload } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import MapModal from "../mapa/MapModal";
import VerDetallesRutaButton from './VerDetallesRutaButton';
import VerFotosEntregaButton from './VerFotosEntregaButton';

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});
const { Option } = Select;

const Rutas = () => {
  if (sessionStorage.getItem("user_mod")) sessionStorage.removeItem("user_mod");

  let info_user = JSON.parse(sessionStorage.getItem("info_user"));

  const { t, i18n } = useTranslation();
  const [bottom, setBottom] = useState("bottomCenter");
  const [original, setOriginal] = useState([]);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [spinning, setSpinning] = useState(false);
  const [spinTitle, setSpinTitle] = useState(t("global.loading"));
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading] = useState(false);
  const [searchValue, setSearchValue] = useState(""); // Estado para controlar el valor del input
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRuta, setSelectedRuta] = useState("");
  const [dataRuta, setDataRuta] = useState("");

  const canAct = selectedRowKeys.length === 1;
  const idSelec = canAct ? selectedRowKeys[0] : undefined;

  const headers = {
    accept: "*/*",
    Authorization: "Bearer " + sessionStorage.getItem("token"),
    "Content-Type": "application/json",
  };

  useEffect(() => {
    recargar();
  }, []);

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const columns = [
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_fechacreacion")}
        </p>
      ),
      dataIndex: "fechacreacion",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.fechacreacion),
        _.isEqual
      ),
      onFilter: (value, record) => record.fechacreacion.startsWith(value),
      sorter: (a, b) => a.fechacreacion - b.fechacreacion,
    },{
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_matricula")}
        </p>
      ),
      dataIndex: "matricula",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.matricula),
        _.isEqual
      ),
      onFilter: (value, record) => record.matricula.startsWith(value),
      sorter: (a, b) => a.matricula - b.matricula,
    },    
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_tipo_vehiculo")}
        </p>
      ),
      dataIndex: "tipo_vehiculo",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.tipo_vehiculo),
        _.isEqual
      ),
      onFilter: (value, record) => record.tipo_vehiculo.startsWith(value),
      sorter: (a, b) => a.tipo_vehiculo - b.tipo_vehiculo,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_chofer")}
        </p>
      ),
      dataIndex: "fullname",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.fullname),
        _.isEqual
      ),
      onFilter: (value, record) => record.fullname.startsWith(value),
      sorter: (a, b) => a.fullname - b.fullname,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_cantidadpaquetes")}
        </p>
      ),
      dataIndex: "cantidadpaquetes",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.cantidadpaquetes),
        _.isEqual
      ),
      onFilter: (value, record) => record.cantidadpaquetes.startsWith(value),
      sorter: (a, b) => a.cantidadpaquetes - b.cantidadpaquetes,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_distanciatotal")}
        </p>
      ),
      dataIndex: "distanciatotal",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.distanciatotal),
        _.isEqual
      ),
      onFilter: (value, record) => record.distanciatotal.startsWith(value),
      sorter: (a, b) => a.distanciatotal - b.distanciatotal,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_tiempoestimado")}
        </p>
      ),
      dataIndex: "tiempoestimado",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.tiempoestimado),
        _.isEqual
      ),
      onFilter: (value, record) => record.tiempoestimado.startsWith(value),
      sorter: (a, b) => a.tiempoestimado - b.tiempoestimado,
    },
    {
      title: (
        <p
          style={{
            margin: 0,
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("ruta.col_estadoruta")}
        </p>
      ),
      dataIndex: "estadoruta",
      width: 150,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.estadoruta),
        _.isEqual
      ),
      onFilter: (value, record) => record.estadoruta.startsWith(value),
      sorter: (a, b) => a.estadoruta.localeCompare(b.estadoruta),
      render: (text, record) => {
        const colorMap = {
          1: "#27ae60", // verde - Disponible
          2: "#e67e22", // naranja - Cancelada
          3: "#2980b9", // azul - Terminada
          4: "#8e44ad", // morado - Cerrada
          5: "#f39c12", // amarillo - En elaboración
        };

        const fallbackColor = "#7f8c8d"; // gris por defecto
        const color = colorMap[record.idestadoruta] || fallbackColor;

        return (
          <span
            style={{
              color,
              fontWeight: "bold",
              fontSize: "14px",
              fontFamily: "'Roboto', sans-serif",
              textShadow: "0.5px 0.5px 1px rgba(0,0,0,0.1)",
            }}
          >
            {text}
          </span>
        );
      },
    }
 /*,{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('ruta.col_ruta')}</p>,
            dataIndex: 'ruta',
            width: 150,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.ruta), _.isEqual),
            onFilter: (value, record) => record.ruta.startsWith(value),
        }*/,
  ];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: data.length, // Asegúrate de tener el total de elementos aquí
  });

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const recargar = () => {
    //limpiar la busqueda del componente Search
    setSearchValue("");

    setSpinTitle(t("global.loading"));
    setSpinning(true);
    setSelectedRowKeys([]);
    let aux = [];

    let start = 0;
    let limit = 1000;

    Axios.post(
      "sd/getRutas",
      {
        // "start": start,
        // "limit": limit,
        // "filtro":[{
        //     "idruta": 1,
        //     "idvehiculo": 1,
        // }]
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              key: response.data.data[i].idruta,
              idruta: response.data.data[i].idruta,
              idvehiculo: response.data.data[i].idvehiculo,
              ruta: response.data.data[i].ruta,
              fechacreacion: response.data.data[i].fechacreacion,
              fechaactualizacion: response.data.data[i].fechaactualizacion,
              cantidadpaquetes: response.data.data[i].cantidadpaquetes,
              distanciatotal: response.data.data[i].distanciatotal,
              tiempoestimado: response.data.data[i].tiempoestimado,
              matricula: response.data.data[i].matricula,
              modelo: response.data.data[i].modelo,
              tipo_vehiculo: response.data.data[i].tipo_vehiculo,
              fullname: response.data.data[i].fullname,
              telefono: response.data.data[i].telefono,
              idestadoruta: response.data.data[i].idestadoruta,
              estadoruta: response.data.data[i].estadoruta,
            });
          }
        }

        setData(aux);
        setOriginal(aux);
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  const getInfoForm = async (id) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].idruta === id) {
        return data[i];
      }
    }
    return [];
  };

  const modificar = async () => {
    form.resetFields();
    const row = await getInfoForm(selectedRowKeys[0]);
    sessionStorage.setItem("user_mod", JSON.stringify(row));
  };

  const onSearch = (value, _e, info) => {
    filterLocal(value);
  };

  const filterLocal = (value) => {
    if (value === "" || value === null) {
      setData(original);
    } else {
      let aux = [];
      original.forEach(function (option) {
        if (
          option.matricula.toUpperCase().indexOf(value.toUpperCase()) !== -1
        ) {
          aux.push(option);
        }
      });
      setData(aux);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length === 1) {
      const selectedRow = data.find((row) => row.key === newSelectedRowKeys[0]);
      if (selectedRow) {
        setSelectedRuta(JSON.parse(selectedRow.ruta));
        setDataRuta(selectedRow);
      }
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  // Función para contar rutas por estado
  const getRouteCountByStatus = () => {
    const statusCount = {
      1: 0, // Disponible
      2: 0, // Cancelada
      3: 0, // Terminada
      4: 0, // Cerrada
      5: 0, // En elaboración
      other: 0 // otros estados
    };

    data.forEach(route => {
      if (statusCount.hasOwnProperty(route.idestadoruta)) {
        statusCount[route.idestadoruta]++;
      } else {
        statusCount.other++;
      }
    });

    return statusCount;
  };

  const routeStatusCounts = getRouteCountByStatus();

  const selectRowUpdate = async (record) => {
    setSelectedRowKeys([record.key]);
    form.resetFields();
    let row = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].idruta === record.key) {
        row = data[i];
      }
    }

    sessionStorage.setItem("user_mod", JSON.stringify(row));
    navigate(`/editTipoVehiculo/${record.key}`);
  };

  function cancelarRuta(e, cancelar) {
    Modal.confirm({
      title: "Cancelar ruta",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>¿Desea cancelar la ruta seleccionada?</span>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        let message = "";
        Axios.post(
          "sd/cancelarRuta",
          {
            idruta: selectedRowKeys[0],
            idestadoruta: cancelar ? 2 : 1,
            data: dataRuta,
            nombreusuario: info_user.nombreusuario,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              message = response.data.message;
              messageApi.open({
                type: "success",
                content: message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: message,
              duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  const cerrarRuta = () => {
    Modal.confirm({
      title: "Cerrar ruta",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>¿Está seguro que desea cerrar la ruta seleccionada?</span>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        Axios.post(
          "sd/updateEstadoRuta",
          {
            idruta: selectedRowKeys[0],
            idestadoruta: 4,
          },
          { headers }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: response.data.message || "Ruta cerrada con éxito",
                duration: 2,
              });
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: response.data.message || "No se pudo cerrar la ruta",
                duration: 3,
              });
            }
          })
          .catch((error) => {
            setSpinning(false);
            const msg =
              error.response?.data?.message ||
              error.response?.data?.error ||
              "Error al cerrar la ruta";
            messageApi.open({
              type: "error",
              content: msg,
              duration: 3,
            });
          });
      },
    });
  };



  function deleteRuta(e, cancelar) {
    Modal.confirm({
      title: "Eliminar ruta",
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <span>¿Desea eliminar la ruta seleccionada?</span>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        let message = "";
        Axios.post(
          "sd/deleteRuta",
          {
            idruta: [selectedRowKeys[0]],
            idvehiculo: dataRuta.idvehiculo,
            nombreusuario: info_user.nombreusuario,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              message = response.data.message;
              messageApi.open({
                type: "success",
                content: message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: message,
              duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: "16px"
    }}>
      <Spin spinning={spinning} tip={spinTitle} size="large">
        {/* Header Principal */}
        <div style={{
          background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
          borderRadius: '8px',
          padding: '12px',
          marginBottom: '12px',
          color: 'white',
          boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
        }}>
          <Row align="middle">
            <Col xs={24} md={16}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <CarOutlined style={{ fontSize: '24px' }} />
                <div>
                  <Typography.Title level={4} style={{ color: 'white', margin: 0, marginBottom: '2px' }}>
                    {t("ruta.title")}
                  </Typography.Title>
                  <Typography.Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
                    Gestión de rutas
                  </Typography.Text>
                </div>
              </div>
            </Col>
            <Col xs={24} md={8} style={{ textAlign: 'right' }}>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{
                  background: 'rgba(255,255,255,0.15)',
                  borderRadius: '4px',
                  padding: '2px 6px',
                  backdropFilter: 'blur(10px)'
                }}>
                  <Typography.Text style={{ color: 'white', fontSize: '10px' }}>
                    Total: {data.length}
                  </Typography.Text>
                </div>
                <div style={{
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '4px',
                  padding: '4px 6px',
                  backdropFilter: 'blur(10px)'
                }}>
                  <Typography.Text style={{ color: 'white', fontSize: '10px' }}>
                    Selec: {selectedRowKeys.length}
                  </Typography.Text>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {contextHolder}

        {/* Cards de Estado */}
        <Row gutter={[12, 12]} style={{ marginBottom: '12px' }} justify="center">
          <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
            <Card
              style={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 2px 8px rgba(39, 174, 96, 0.3)',
                background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)',
                height: '80px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              styles={{ body: { padding: '12px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(39, 174, 96, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(39, 174, 96, 0.3)';
              }}
            >
              <Typography.Text style={{ color: 'white', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '4px' }}>
                Disponible
              </Typography.Text>
              <Typography.Title level={3} style={{ color: 'white', margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                {routeStatusCounts[1]}
              </Typography.Title>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
            <Card
              style={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 6px 20px rgba(243, 156, 18, 0.3)',
                background: 'linear-gradient(135deg, #f39c12 0%, #f1c40f 100%)',
                height: '80px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              styles={{ body: { padding: '12px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(243, 156, 18, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(243, 156, 18, 0.3)';
              }}
            >
              <Typography.Text style={{ color: 'white', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '4px' }}>
                En elaboración
              </Typography.Text>
              <Typography.Title level={3} style={{ color: 'white', margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                {routeStatusCounts[5]}
              </Typography.Title>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
            <Card
              style={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 6px 20px rgba(41, 128, 185, 0.3)',
                background: 'linear-gradient(135deg, #2980b9 0%, #3498db 100%)',
                height: '80px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              styles={{ body: { padding: '12px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(41, 128, 185, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(41, 128, 185, 0.3)';
              }}
            >
              <Typography.Text style={{ color: 'white', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '4px' }}>
                Terminada
              </Typography.Text>
              <Typography.Title level={3} style={{ color: 'white', margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                {routeStatusCounts[3]}
              </Typography.Title>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
            <Card
              style={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 6px 20px rgba(142, 68, 173, 0.3)',
                background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                height: '80px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              styles={{ body: { padding: '12px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(142, 68, 173, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(142, 68, 173, 0.3)';
              }}
            >
              <Typography.Text style={{ color: 'white', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '4px' }}>
                Cerrada
              </Typography.Text>
              <Typography.Title level={3} style={{ color: 'white', margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                {routeStatusCounts[4]}
              </Typography.Title>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
            <Card
              style={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 6px 20px rgba(230, 126, 34, 0.3)',
                background: 'linear-gradient(135deg, #e67e22 0%, #f39c12 100%)',
                height: '80px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              styles={{ body: { padding: '12px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(230, 126, 34, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(230, 126, 34, 0.3)';
              }}
            >
              <Typography.Text style={{ color: 'white', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '4px' }}>
                Cancelada
              </Typography.Text>
              <Typography.Title level={3} style={{ color: 'white', margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                {routeStatusCounts[2]}
              </Typography.Title>
            </Card>
          </Col>

          {routeStatusCounts.other > 0 && (
            <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
              <Card
                style={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 6px 20px rgba(127, 140, 141, 0.3)',
                  background: 'linear-gradient(135deg, #7f8c8d 0%, #95a5a6 100%)',
                  height: '80px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                styles={{ body: { padding: '12px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(127, 140, 141, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(127, 140, 141, 0.3)';
                }}
              >
                <Typography.Text style={{ color: 'white', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '4px' }}>
                  Otros
                </Typography.Text>
                <Typography.Title level={3} style={{ color: 'white', margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                  {routeStatusCounts.other}
                </Typography.Title>
              </Card>
            </Col>
          )}
        </Row>

        {/* Panel de Herramientas */}
        <Card
          style={{
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: 'none',
            marginBottom: '12px'
          }}
          styles={{ body: { padding: '12px' } }}
        >
          <Row justify="center" align="middle" gutter={[8, 8]}>
            <Col xs={24}>
              <Space wrap size="small" style={{ justifyContent: 'center', width: '100%' }}>
                <Tooltip title={t("ruta.details")}>
                  <Button
                    type="primary"
                    icon={<DeploymentUnitOutlined />}
                    onClick={() => setIsModalOpen(true)}
                    disabled={loading || selectedRowKeys.length !== 1}
                    size="small"
                    style={{
                      background: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)'
                        : '#d9d9d9',
                      borderColor: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#253289'
                        : '#d9d9d9',
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      color: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'white'
                        : '#000000',
                      boxShadow: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '0 2px 8px rgba(37, 50, 137, 0.3)'
                        : 'none'
                    }}
                  >
                    {t("ruta.details")}
                  </Button>
                </Tooltip>

                <Tooltip title={t("ruta.more_details")}>
                  <span style={{ display: 'inline-block' }}>
                    <VerDetallesRutaButton
                      idruta={idSelec}
                      headers={headers}
                    />
                  </span>
                </Tooltip>

                <Tooltip title={t("ruta.photos_delivery")}>
                  <span style={{ display: 'inline-block' }}>
                    <VerFotosEntregaButton idruta={idSelec} headers={headers} />
                  </span>
                </Tooltip>

                <Tooltip title={t("ruta.recepcion")}>
                  <Link to={`/recepcion/${idSelec}`}>
                    <Button
                      type="primary"
                      icon={<MdAddHome />}
                      disabled={
                        selectedRowKeys.length !== 1 ||
                        dataRuta?.idestadoruta !== 3
                      }
                      size="small"
                      style={{
                        background: selectedRowKeys.length === 1 && dataRuta?.idestadoruta === 3
                          ? 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)'
                          : '#d9d9d9',
                        borderColor: selectedRowKeys.length === 1 && dataRuta?.idestadoruta === 3
                          ? '#27ae60'
                          : '#d9d9d9',
                        borderRadius: '8px',
                        height: '32px',
                        fontWeight: '500',
                        color: selectedRowKeys.length === 1 && dataRuta?.idestadoruta === 3
                          ? 'white'
                          : '#000000',
                        boxShadow: selectedRowKeys.length === 1 && dataRuta?.idestadoruta === 3
                          ? '0 2px 8px rgba(39, 174, 96, 0.3)'
                          : 'none'
                      }}
                    >
                      {t("ruta.recepcion")}
                    </Button>
                  </Link>
                </Tooltip>

                <Tooltip title={t("ruta.cancelar")}>
                  <Button
                    type="primary"
                    danger
                    icon={<CloseCircleOutlined />}
                    onClick={(e) => {
                      cancelarRuta(e, true);
                    }}
                    disabled={loading || selectedRowKeys.length !== 1}
                    size="small"
                    style={{
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      background: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      borderColor: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      color: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'white'
                        : '#000000'
                    }}
                  >
                    {t("ruta.cancelar")}
                  </Button>
                </Tooltip>

                <Tooltip title={t("ruta.delete")}>
                  <Button
                    type="primary"
                    danger
                    icon={<AiFillDelete />}
                    onClick={(e) => {
                      deleteRuta(e, true);
                    }}
                    disabled={loading || selectedRowKeys.length !== 1}
                    size="small"
                    style={{
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      background: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      borderColor: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      color: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'white'
                        : '#000000'
                    }}
                  >
                    {t("ruta.delete")}
                  </Button>
                </Tooltip>

                <Tooltip title={t("global.reload")}>
                  <Button
                    type="primary"
                    icon={<IoReload />}
                    onClick={recargar}
                    loading={loading}
                    size="small"
                    style={{
                      background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                      borderColor: '#253289',
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                    }}
                  >
                    {t("global.reload")}
                  </Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Tabla de Rutas */}
        <Card
          style={{
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: 'none'
          }}
          styles={{ body: { padding: '0' } }}
          title={
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 16px',
              borderBottom: '1px solid #f0f0f0'
            }}>
              <Typography.Title level={5} style={{ margin: 0, color: '#253289' }}>
                Lista de Rutas
              </Typography.Title>
              <Space>
                <Input.Search
                  placeholder={t("ruta.search")}
                  style={{ width: '160px' }}
                  size="small"
                  onSearch={onSearch}
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    filterLocal(e.target.value);
                  }}
                  allowClear
                />
              </Space>
            </div>
          }
        >
          <Table
            size="small"
            bordered={false}
            columns={columns}
            dataSource={data}
            rowSelection={rowSelection}
            onChange={handleTableChange}
            scroll={{ x: 1200 }}
            style={{
              background: 'white',
              borderRadius: '8px'
            }}
            pagination={{
              position: [bottom],
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total) => `Total ${total} elementos`,
              style: {
                padding: '8px 12px',
                borderTop: '1px solid #f0f0f0'
              }
            }}
            onRow={(record) => {
              return {
                onDoubleClick: async () => {
                  // selectRowUpdate(record);
                },
              };
            }}
          />
        </Card>

        <MapModal
          isVisible={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          coordinates={selectedRuta}
        />
      </Spin>
    </div>
  );
};
export default Rutas;
